import React, { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'

// import { Form } from 'informed'
import { useParams } from 'react-router-dom'
// import * as moment from 'moment'

// import { DateTimePicker } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
// import Button from 'components/Button'
import useQuery from 'components/graphql/hooks/useQuery'
import { useMutation, updateQuery } from 'components/graphql'
// import { DataTable } from 'components/DataTable'
import DataTable from 'components/DataTableTest'

// import CardImport from '../modals/History/CardImport.js'
// import { History } from '../../../media/icons'
import DefaultOrderModal from '../modals/DefaultOrderModal'
import deleteStandardOrderMutation from '../gql/mutation/deleteStandardOrder'
import query from '../gql/getCreditClient'
import { getStandardOrderValues } from '../gql/'

// import { defaultOrder } from '../tableColumns'
import { defaultOrder1 } from '../tableColumns'

const DefaultOrder = (props) => {
	const [t] = useTranslation()
	/* const dateInterval = {
		to: moment(new Date()).utc().endOf('day').toISOString(),
		from: moment(new Date()).utc().startOf('day').toISOString()
	} */
	const [addEditShow, setAddEditShow] = useState(false)
	const [productData, setProductData] = useState(null)
	const [deleteStandardOrder] = useMutation(deleteStandardOrderMutation)
	const isDisabled = props?.data?.FA_Id && (props.data.FA_Id !== null) && (props.data.FA_Id !== '') ? true : false

	let label = t('credit_client_section.strings.connected_with_registers') + ': '

	const { id } = useParams()

	const { data } = useQuery(getStandardOrderValues, {
		fetchPolicy: 'cache-first',
		variables: { filter: { creditClientId: id } }
	})

	const itemData = useQuery(query, {
		fetchPolicy: 'cache-first',
		variables: { id: id }
	})

	if (itemData?.data?.getCreditClient?.connectedCRs) {
		const ccr = itemData.data.getCreditClient.connectedCRs.reduce((prev, cur) => (prev.concat(cur.name)), [])
		label += ccr.join(', ')
	}

	const weekDays = [
		t('common.dates.monday'),
		t('common.dates.tuesday'),
		t('common.dates.wednesday'),
		t('common.dates.thursday'),
		t('common.dates.friday'),
		t('common.dates.saturday'),
		t('common.dates.sunday')
	]

	let groupedRows = null
	let tableItems = []
	let existProducts = []
	if (data?.listOrderItems?.items) {
		const rows = []
		const tableData = []
		data.listOrderItems.items.forEach(item => {
			existProducts.push(item?.product?.id)
			// To define grouped rows use groupBy column name + ':' + column value
			rows.push(`Nummer:${item.product.code}`)
			for (let i = 0; i < 7; i++) {
				tableData.push({
					id: item.id,
					productId: item?.product?.id,
					Nummer: item?.product?.code,
					Bezeichnung: item?.product?.name,
					Info: item?.product?.isActive ? '' : t('credit_client_section.strings.article_is_not_active'),
					Tage: weekDays[i],
					Menge: item.weekAmount[i],
					MengeNeu: item.weekAmountNew[i],
					Minimum: item.weekMinAmount[i],
					Maximun: item.weekMaxAmount[i],
					Alloted: item.weekAllottedAmount[i]
				})
			}
		})
		groupedRows = rows
		tableItems = tableData
	}

	/* const tableActions = [{
		label: t('credit_client_section.strings.history'),
		Icon: History,
		iconStyles: `margin-bottom: 6px;`,
		modalComponent: CardImport
	}] */

	// for export
	/* const requestData = (formData) => {
	} */

	const handleMutateRow = mutateVals => {
		// 'mutateVals' is id if deleting and 'mutateVals' is an object of vals if editing
		const isDeleting = typeof mutateVals === 'string' || typeof mutateVals === 'number'
		if (isDeleting) {
			deleteStandardOrder({
				variables: { id: mutateVals },
				update: updateQuery({
					query: getStandardOrderValues,
					variables: { filter: { creditClientId: id } } }, (draft, { mutationResult, readQuery, queryField }) => {
					const newData = readQuery.items.filter((item = {}) => Number(item.id) !== Number(mutationResult.id))
					draft[queryField].items = newData
				})
			})
		} else {
			setProductData(data.listOrderItems.items.find(el => el.id === mutateVals.id))
			setAddEditShow(true)
		}
	}

	return (
		<Fragment>
			{/* <ContentBlock>
				<Form
					onSubmit={(values) => requestData(values)}
					initialValues={{ dateInterval }}
					render={({ formState }) => (
						<Fragment>
							<DateTimePicker
								picker='date'
								label={{ from: t('common.fields.from_date'), to: t('common.fields.to_date') }}
								field='dateInterval'
								interval/>
							<Button type='submit' status='primary' text={t('common.buttons.calculate')}/>
						</Fragment>
					)}/>
			</ContentBlock> */}
			<ContentBlock>
				{/* <DataTable
					minRows={0}
					data={tableItems}
					columns={defaultOrder(t)}
					label={label}
					isInsideContentBlock={true}
					tableActions={tableActions}
					pivotBy={['Nummer']}
					withSearch
					onSearch={searchHandler}
					onAddRecord={() => setAddEditShow(true)}
					mutateRow={{
						editBtn: true,
						onRowMutate: handleMutateRow
					}}
				/> */}
				<DataTable
					data={tableItems}
					groupBy={{ columns: ['Nummer'] }}
					columns={defaultOrder1(t)}
					label={label}
					height={470}
					isInsideContentBlock={true}
					// tableActions={tableActions}
					withSearch
					onAddRecord={isDisabled ? false : () => setAddEditShow(true) }
					mutateRow={isDisabled ? false : {
						editBtn: true,
						onRowMutate: handleMutateRow,
						groupedRows
					}}
				/>
			</ContentBlock>
			{addEditShow &&
				<DefaultOrderModal
					creditClientId={id}
					data={productData}
					existProducts={existProducts}
					unmount={() => {
						setAddEditShow(false)
						setProductData(null)
					}}/>}
		</Fragment>
	)
}

export default DefaultOrder
